import React from 'react'

const Footer = () => {
  return (
    <div className="footer">designed in figma, built in react. by vivek</div>
  )
}

export default Footer